<template>
    <header class="header" id="header">
        
        <div class="wrap-mobile">
            <button class="wrap-sandwich" id="sandwich" @click="openMenuMob()" :aria-expanded="isMenuOpen.toString()" aria-label="Abrir menu" aria-controls="wrap-menu-mob">
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div class="logo" @click="goto('#home')" @keyup.enter="goto('#home')" tabindex="0" role="button" aria-label="Ir para o início">
                <h1>
                    <img src="../assets/images/encinterativa-logo.png" alt="ENC Interativa">
                </h1>
            </div>
        </div>

        <div class="wrap-menu" id="wrap-menu-mob">

            <nav>
                <ul>
                    <li
                        v-for="(item, key) in menuItems"
                        :key="key"
                    >
                        <a
                            :href="item.path"
                            :tabindex="isMobile && !isMenuOpen ? -1 : 0"
                            :class="{ activeItem: activeItem == item.linkActive }"
                            @click.prevent="goto(item.param)">
                            {{item.label}}
                        </a>
                    </li>
                </ul>
                <div class="phone only-mob">
                    <a href="tel:551137917204" :tabindex="isMobile && !isMenuOpen ? -1 : 0">
                        <b-icon icon="telephone" scale="1" variant="info"></b-icon> <strong>(11) 3791-7204</strong>
                    </a>
                </div>
            </nav>
            
            <div class="phone only-desk">
                <a href="tel:551137917204">
                    <b-icon icon="telephone" scale="1" variant="info"></b-icon> (11) 3791-7204
                </a>
            </div>
    </div>

    </header>
</template>

<script>
    import {
    scroller
} from "vue-scrollto/src/scrollTo";

    export default {
        data() {
            return {
                activeItem : false,//'#home',
                isMenuOpen: false,
                isScrolling: false,
                isMobile: window.innerWidth <= 992,
                menuItems: [
                    {id: 1, label: 'Home',      param: '#home',         path: '/home/',         linkActive: '#home'        },
                    {id: 2, label: 'Clientes',  param: '#clientes',         path: '/clientes/',         linkActive: '#clientes'        },
                    {id: 3, label: 'Sobre',     param: '#sobre',        path: '/sobre/',        linkActive: '#sobre'       },
                    {id: 4, label: 'Serviços',  param: '#servicos',     path: '/servicos/',     linkActive: '#servicos'    },
                    {id: 5, label: 'Trabalhos', param: '#trabalhos',    path: '/trabalhos/',    linkActive: '#trabalhos'   },
                    {id: 6, label: 'Contatos',  param: '#contatos',     path: '/contatos/',     linkActive: '#contatos'    },
                ]
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.checkMobile);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.checkMobile);
        },
        methods:{
            openMenuMob(){
                this.isMenuOpen = !this.isMenuOpen;
                document.getElementById("sandwich").classList.toggle("motion-in");
                document.getElementById("header").classList.toggle("motion-in");

                if (this.isMenuOpen) {
                    this.$nextTick(() => {
                        const firstLink = document.querySelector('#wrap-menu-mob a');
                        if (firstLink) firstLink.focus();
                    });
                } else {
                    document.getElementById('sandwich').focus();
                }
            },
            checkMobile() {
                this.isMobile = window.innerWidth <= 992;
            },
            scrollIntoView(event) {
                event.preventDefault()
                const href = event.target.getAttribute('href')
                //console.log(event.target.getAttribute('href'))
                const el = href ? document.querySelector(href) : null
                if (el) {
                    this.$refs.content.scrollTop = el.offsetTop
                }
            },
            goto(param) {

                if(document.getElementById("header").className != 'header'){
                    this.openMenuMob();
                }

                // Remove foco do item de menu para não bloquear o scrollspy
                if (document.activeElement) document.activeElement.blur();

                // Cancelar scroll anterior se ainda estiver rodando
                if (this._cancelScroll) this._cancelScroll();

                this.isScrolling = true;
                this.activeItem = param;
                const firstScrollTo = scroller();
                this._cancelScroll = firstScrollTo(param, 500, {
                    easing: [0.0, 0.82, 0.165, 1.0],
                    offset: (window.innerWidth <= 768) ? -80 : -document.getElementById('header').offsetHeight,
                    cancelable: false,
                    onDone: () => {
                        this._cancelScroll = null;
                        this.activeMenu(param);
                        setTimeout(() => { this.isScrolling = false; }, 50);
                    },
                    onCancel: () => { this._cancelScroll = null; },
                });

            },
            activeMenu(param) {
                if(param != this.$route.hash){
                    this.$router.push({
                        hash: param
                    });
                }
                this.activeItem = param;
            },
            getPos(elmTop) {
                document.querySelector(elmTop).offsetTop
            },
            handleScroll (){
                if (this.isScrolling) return;
                const focused = document.activeElement;
                if (focused && focused.closest('#wrap-menu-mob nav')) return;
                let currentSection = null;
                const headerHeight = document.querySelector("#header").offsetHeight;
                const els = document.querySelectorAll('section, .section')
                els.forEach((el) => {
                    const elTop = el.getBoundingClientRect().top
                    const elBottom = el.getBoundingClientRect().bottom
                    if ( (elTop - headerHeight - 100)  <= 0 && elBottom >= 0) {
                        currentSection = el;
                    }
                })
                if (currentSection) {
                    this.activeMenu("#"+currentSection.getAttribute('id'));
                }
				// document.addEventListener('scroll', function () {
                    

                // }, {
                //     passive: true
                // });

            },
        },
        mounted(){
            setTimeout(() => {
                this.getPos(this.$route.hash)

                if(!this.$route.hash){
                    this.$router.push({
                        path: this.activeItem
                    });
                } else {
                    this.goto(this.$route.hash);
                }
            }, 200);      
			
			this.handleScroll();
        }
}
</script>
<style scoped lang='scss'>
    @use 'sass:color'; 
    @import "../assets/scss/global";
    header{
        background: $white;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        border-bottom: 1px solid rgba($color: $cor2, $alpha: .2);
        z-index: 10;
        min-height: $menuHeight;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .wrap-mobile{
            
            .wrap-sandwich{
                display: none;
            }
        }
        
        .logo{
            cursor: pointer;
            width: 100px;
            border-radius: 4px;
            &:focus-visible{
                outline: 2px solid $cor1;
                outline-offset: 4px;
            }
        }

        .wrap-menu{
            width: 100%;
            min-height: $menuHeight;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        a{
            text-transform: uppercase;
            position: relative;
            font-size: 16px;
            color: $cor2;
            text-decoration: none;
        }
        
        
        nav{
            ul{
                display: flex;
                justify-content: space-between;
                align-items: center;
                li{
                    padding: 2px 3px;
                    a{
                        text-transform: uppercase;
                        position: relative;
                        font-size: 16px;
                        font-weight: 400;
                        color: $cor2;
                        text-decoration: none;
                        border-radius: 4px;
                        padding: 4px 8px;
                        transition: background .3s ease;
                        &:after{
                            content: '';
                            position: absolute;
                            left: 8px;
                            bottom: -41px;
                            height: 4px;
                            background: $cor1;
                            width: 0;
                        }
                        &:hover, &:focus-visible, &.activeItem{
                            outline: none;
                            background: $cor1;
                            text-shadow: 0 0 0.8px $cor2, 0 0 0.8px $cor2, 0 0 0.8px $cor2;
                        }
                        &.activeItem{
                            &:after{
                                width: calc(100% - 16px);
                            }
                        }
                    }
                }
            }
        }
        .phone{
            margin-left: 20px;
            border-left: 2px solid rgba($cor2, .4);
            padding-left: 20px;
            a{
                transition: background .3s ease;
                border-radius: 4px;
                padding: 4px 8px;
                &:is(:hover, :focus-visible){
                    outline: none;
                    background: $cor1;
                    text-shadow: 0 0 0.8px $cor2, 0 0 0.8px $cor2, 0 0 0.8px $cor2;
                }
            }
            @media(max-width:$screenMD){
                margin-left: 14px;
                a{
                    font-weight: 900;
                }
            }
        }
        @media(max-width:$screenLG) {
            //transition: all .0s ease-in;
            background: $white;
            min-height: 60px;
            display: flex;
            flex-flow: column;
            align-items: flex-start;
            justify-content: center;
            color: $cor2;
            .wrap-mobile{
                padding: 20px 0;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .wrap-sandwich{
                    background: none;
                    border: none;
                    padding: 0;
                    cursor: pointer;
                    border-radius: 4px;
                    display: flex;
                    width: 45px;
                    height: 25px;
                    position: relative;
                    flex-flow: column;
                    align-items: center;
                    justify-content: center;
                    &:focus-visible{
                        outline: 2px solid $cor1;
                        outline-offset: 6px;
                    }
                    span,span:first-child,span:last-child{
                        background-color: $cor1;
                        transition: all .3s ease;
                    }
                    span{
                        position: absolute;
                        left: 0;
                        width: 100%;
                        height: 3px;
                        margin: auto 0;
                        &:first-child{
                            transform-origin: left top;
                            top: 0;
                        }
                        &:last-child{
                            bottom: 0;
                        }
                    }
                    &.motion-in{                    
                        span{
                            &:nth-child(2){
                                width: 0;
                            }
                            &:first-child{
                                transform: rotate(40deg);
                            }
                            &:last-child{
                                transform: rotate(-40deg) translate(0px, -10px)
                            }
                        }
                    }
                }
            }
            .wrap-menu{
                transition: all .5s ease-in-out;
                min-height: auto;
                align-items: flex-start;
                justify-content: flex-start;
                height: 0;
                overflow: hidden;
                nav{
                    ul{
                        margin: 20px 0;
                        flex-flow: column;
                        align-items: flex-start;
                        li{
                            a{
                                font-size: 24px;
                                text-align: left;
                                color: $white;
                                color: $cor2;
                                &:after{
                                    //width: 100%;
                                    bottom: 0px;
                                }
                                &:hover,
                                &:focus{
                                    bottom: 0;
                                }
                            }
                        }
                    }
                }                
            }
            &.motion-in{
                .wrap-menu{
                    height: 100vh;
                }
            }
        }
    }

</style>
